import { render, staticRenderFns } from "./TakeVaccinne.vue?vue&type=template&id=a61c8976&"
import script from "./TakeVaccinne.vue?vue&type=script&lang=js&"
export * from "./TakeVaccinne.vue?vue&type=script&lang=js&"
import style0 from "./TakeVaccinne.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports